import { sampleAuditPass, singleSyncCooperate, batchCancelCooperate, singleSyncPartnerCooperate, cancelPartnerCooperate } from '@/api/sampleOrder';
export default {
	methods: {
		//选中
		selectionChange(val) {
			this.selectionShopArr = val;
		},
		//编辑商品机制
		editProductFun(row, tabName) {
			this.$refs.editProduct.initEditFun(row, tabName);
		},
		//发货
		sendGoodsFun(row, tabName, state) {
			this.$refs.sendGood.initSendFun(row, tabName, state);
		},
		//样品订单发货
		sampleSendGoodsFun(row) {
			this.$refs.sampleSendGoods.show(row);
		},
		//合作数据
		cooperFun(row, tabName) {
			this.$refs.cooperData.initCooperFun(row, tabName);
		},
		//更改商品链接
		replaceLinkFun(row, tabName, title) {
			this.$refs.replaceLink.initLinkFun(row, tabName, title);
		},
		//拒绝带发货
		refuseFun(row, state, tabName) {
			this.$refs.refuse.initrefuseFun(row, state, tabName);
		},
		//拒绝带发货原因
		reasonFun(row, state, tabName) {
			this.$refs.reason.initReasonFun(row, state, tabName);
		},
		//申请样品
		applyFun(row, tabName) {
			this.$refs.apply.initApplyFun(row, tabName);
		},
		//变更详情 //前端
		changeFun(row, tabName) {
			this.$refs.change.initChange(row, tabName);
		},
		//查看变更详情  //回写
		changeDFun(row, tabName) {
			this.$refs.changeDetails.initCDhange(row, tabName);
		},
		//多功能弹框
		multiFun(row, state, tabName, isKsPlatform) {
			this.$refs.multi.initMulti(row, state, tabName, isKsPlatform);
		},
		//确认开播, 确认带货
		beginFun(row, state, tabName) {
			this.$refs.begin.initBeginFun(row, state, tabName);
		},
		//批量发货
		importFun(row) {
			this.$refs.importDialog.importInit(row);
		},
		//批量导入
		batchImport() {
			this.$refs.batchImportDialog.show();
		},
		// 导入记录
		goToPage() {
			// this.$router.push('/sample/importLog');
			const routeLink = this.$router.resolve({
				path: '/sample/importLog',
			});
			window.open(routeLink.href, '_blank');
		},
		// 批量拒绝发货
		batchRefuseFun(row) {
			row.length > 0 ? this.$refs.batchRefuse.show(row) : this.$message.warning('请选择需要拒绝的订单');
		},
		//查看详情
		detailsFun(row, tabName) {
			if (!this.$auth.hasPermi('system:cooperationProgress-details-query')) {
				this.$message.warning('暂无合作进度详情页面权限');
				return;
			}
			const routeLink = this.$router.resolve({
				path: '/cooperationProgress/details',
				query: {
					cooperate_id: row.cooperate_id,
					tabName: tabName,
				},
			});
			window.open(routeLink.href, '_blank');
		},
		//查看手卡
		lookCard(row, state) {
			this.$refs.handCardDialog.seeHandCard(row);
		},

		//是否移出选品表
		isRemove(row) {
			if (this.$auth.hasPermi('system:sampleOrder:ClosedSample') && this.tabName == '0') {
				return true;
			} else {
				return false;
			}
		},
		//是否查看手卡
		isLookCard(row) {
			if (row && row?.hand_card) {
				return true;
			} else {
				return false;
			}
		},
		//是否查看变更机制
		isChange(row) {
			if (row.is_change == this.changeStatus.yes && (this.tabName == '0' || this.tabName == '1')) {
				return true;
			} else {
				return false;
			}
		},
		//查看关联样品订单
		viewSampleOrder(row) {
			const routeLink = this.$router.resolve({
				path: '/sample/list',
				query: {
					cooperate_id: row.cooperate_id,
				},
			});
			window.open(routeLink.href, '_blank');
		},

		//通过
		async passFun(params) {
			await sampleAuditPass(params);
			this.$message.success('操作成功！');
			this.refreshList();
		},

		//拒绝申请弹框
		refuseApplyFun(params) {
			this.$refs.refuseApply.show(params, 'single');
		},

		//同步样品协作
		async syncCollaborateFun(params) {
			const { fail = [] } = await singleSyncCooperate(params);
			if (fail.length) {
				this.$message.error('同步失败，无法发送协作申请原因详见单个样品订单');
			} else {
				this.$message.success('操作成功！');
			}
			this.refreshList();
		},

		// 同步星选协作
		async syncStarCollaborateFun(params) {
			const { fail = [] } = await singleSyncPartnerCooperate(params);
			if (fail.length) {
				this.$message.error('同步失败，无法取消协作原因详见单个样品订单');
			} else {
				this.$message.success('操作成功！');
			}
			this.refreshList();
		},

		//取消样品协作
		async cancelCollaborateFun(params) {
			const { errorCount } = await batchCancelCooperate(params);
			if (errorCount) {
				return this.$message.error('取消绑定失败，请刷新重试！');
			} else {
				this.$message.success('操作成功！');
			}
			this.refreshList();
		},
		// 取消星选样品协作
		async cancelStarCollaborateFun(params) {
			const { errorCount } = await cancelPartnerCooperate(params);
			if (errorCount) {
				return this.$message.error('取消绑定失败，请刷新重试！');
			} else {
				this.$message.success('操作成功！');
			}
			this.refreshList();
		},
	},
};
